export default __webpack_public_path__ + "static/media/phone_device.881f6c52.png";